import { 
  RocketLaunchIcon, 
  CommandLineIcon, 
  PlusIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';

const quickActions = [
  {
    name: 'Create API Key',
    description: 'Generate a new API key',
    icon: PlusIcon,
    color: 'bg-emerald-500/10 text-emerald-300',
  },
  {
    name: 'API Playground',
    description: 'Test API endpoints',
    icon: CommandLineIcon,
    color: 'bg-blue-500/10 text-blue-300',
  },
  {
    name: 'View Documentation',
    description: 'Access API guides & docs',
    icon: DocumentTextIcon,
    color: 'bg-purple-500/10 text-purple-300',
  },
];

const achievements = [
  { label: 'Projects Created', value: '12' },
  { label: 'Models Integrated', value: '5' },
  { label: 'API Calls This Month', value: '125K' },
];

export default function WelcomeSection() {
  return (
    <div className="glass-panel">
      <div className="px-8 py-6 flex items-center justify-between border-b border-white/[0.05]">
        <div className="flex items-center space-x-4">
          <div className="p-3 rounded-xl bg-gradient-to-br from-magick-purple/20 to-magick-purple/10">
            <RocketLaunchIcon className="h-6 w-6 text-magick-purple" />
          </div>
          <div>
            <h1 className="text-xl font-medium text-white">
              Welcome back, Mark
            </h1>
            <p className="text-sm text-white/50 mt-0.5">
              Here's what's happening with your AI projects
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-6">
          {achievements.map((achievement) => (
            <div key={achievement.label} className="text-center">
              <div className="text-xl font-semibold text-white">
                {achievement.value}
              </div>
              <div className="text-sm text-white/50">
                {achievement.label}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="p-8 grid grid-cols-3 gap-6">
        {quickActions.map((action) => (
          <button
            key={action.name}
            className="glass-panel-dark p-6 text-left group hover:ring-2 hover:ring-white/[0.05] transition-all duration-200"
          >
            <div className="flex items-center space-x-4">
              <div className={`p-3 rounded-lg ${action.color}`}>
                <action.icon className="h-6 w-6" />
              </div>
              <div>
                <div className="font-medium text-white group-hover:text-magick-purple transition-colors duration-200">
                  {action.name}
                </div>
                <div className="text-sm text-white/50">
                  {action.description}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
